import { CloudUploadOutlined, FilePdfOutlined } from '@ant-design/icons'
import {
  Button,
  DatePicker,
  Form,
  Input,
  message,
  Select,
  Tabs,
  Upload,
} from 'antd'
import { inject, observer } from 'mobx-react'
import React, { memo, useCallback, useState } from 'react'
import { Helmet } from 'react-helmet/es/Helmet'
import ContentBlockWrapper from '../../../components/ContentBlockWrapper'
import PageTitle from '../../../components/PageTitle'
import { DATE_FORMAT_LIST } from '../../../constants'
import { Container } from '../../../layouts/Container/Container'
import DashboardLayout from '../../../layouts/DashboardLayout'
import validator from '../../../validator'
import {
  FormActionFooter,
  ViewDetailContent,
} from './BoardResolutionMinutesCreateStyled'
import { ArrowLeftBroken } from '../../../components/AppIcon'
import DraggerUploadButton from '../../../components/Common/DraggerUploadButton'
import AppPageHeader from '../../../components/AppPageHeader'

const BoardResolutionMinutesCreatePage = props => {
  const { Option } = Select
  const {
    loadingAnimationStore,
    boardResolutionMinutesStore,
    history,
    fileStore,
  } = props

  const [form] = Form.useForm()
  const [fileList, setFileList] = useState([])
  const [fileListNQ, setFileListNQ] = useState([])

  const handleAddFileToUpload = () => false

  const renderFileItem = (originNode, file, fileList, actions) => (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 6,
        padding: '4px 0',
      }}>
      <FilePdfOutlined
        style={{ color: '#ff4d4f', fontSize: 14, flexShrink: 0 }}
      />
      <span
        style={{
          flex: 1,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }}>
        {file.name}
      </span>
      <span
        onClick={actions.remove}
        style={{
          cursor: 'pointer',
          color: '#8c8c8c',
          fontSize: 12,
          flexShrink: 0,
        }}>
        ✕
      </span>
    </div>
  )

  const handleChangeFile = useCallback(
    info => {
      form.setFieldsValue({ attachment_minutes: info.fileList })
      setFileList(info.fileList)
    },
    [form]
  )

  const handleChangeFileNQ = useCallback(
    info => {
      form.setFieldsValue({ attachment_solution: info.fileList })
      setFileListNQ(info.fileList)
    },
    [form]
  )

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const handleSubmitForm = async values => {
    loadingAnimationStore.showSpinner(true)
    try {
      let fileIds = []
      if (Array.isArray(values.attachment_minutes)) {
        for (let file of values.attachment_minutes) {
          const formData = new FormData()
          formData.append('file', file.originFileObj)
          const res = await fileStore.uploadFile(formData)
          fileIds.push(res.data.file_id)
        }
      }

      let fileIdsNQ = []
      if (Array.isArray(values.attachment_solution)) {
        for (let file of values.attachment_solution) {
          const formDataNQ = new FormData()
          formDataNQ.append('file', file.originFileObj)
          const resNQ = await fileStore.uploadFile(formDataNQ)
          fileIdsNQ.push(resNQ.data.file_id)
        }
      }

      const submitValues = {
        ...values,
        attachments_minutes: fileIds,
        attachments_resolution: fileIdsNQ,
      }
      delete submitValues.attachment_minutes
      delete submitValues.attachment_solution

      handleCreateBoardHDQT(submitValues)
    } catch (error) {
      message.error(error.vi)
      loadingAnimationStore.showSpinner(false)
    }
  }

  const handleCreateBoardHDQT = useCallback(
    submitData => {
      boardResolutionMinutesStore
        .createBoardResolutionMinutes(submitData)
        .then(() => {
          boardResolutionMinutesStore.resetFilter()
          history.push({ pathname: '/board-resolution-minutes-hdqt' })
          loadingAnimationStore.showSpinner(false)
          message.success('Tạo biên bản mới thành công')
        })
        .catch(error => {
          loadingAnimationStore.showSpinner(false)
          message.error(error.vi)
        })
    },
    [boardResolutionMinutesStore, history, loadingAnimationStore]
  )

  const handleCancel = () => {
    form.resetFields()
    boardResolutionMinutesStore.resetFilter()
    history.push('/board-resolution-minutes-hdqt')
  }

  const options = [
    { label: 'Đã bãi bỏ', value: 'ABOLISHED' },
    { label: 'Hết hiệu lực', value: 'EXPIRED' },
    { label: 'Còn hiệu lực', value: 'ACTIVE' },
  ]

  const renderFormContent = () => (
    <Form
      scrollToFirstError={true}
      layout="vertical"
      form={form}
      name={'add-board-form'}
      onFinish={handleSubmitForm}>
      <div className="custom-create-page-content-wrapper">
        <Form.Item
          name={'document_name'}
          label={'Tên văn bản'}
          rules={[
            { required: true, message: 'Vui lòng nhập tên văn bản' },
            { validator: validator.validateInputString },
          ]}>
          <Input placeholder={'Nhập tên văn bản'} />
        </Form.Item>

        <Form.Item
          name={'document_number'}
          label={'Số quyết định ban hành'}
          rules={[
            {
              required: true,
              message: 'Vui lòng nhập số quyết định ban hành',
            },
            { validator: validator.validateInputString },
          ]}>
          <Input placeholder={'Nhập số quyết định ban hành'} />
        </Form.Item>

        <Form.Item
          name={'issue_date'}
          label={'Ngày ban hành'}
          rules={[{ required: true, message: 'Vui lòng chọn ngày ban hành' }]}>
          <DatePicker style={{ width: '100%' }} format={DATE_FORMAT_LIST} />
        </Form.Item>

        {/* <Form.Item name={'issue_level'} label={'Cấp ban hành'}>
            <Input placeholder={'Nhập cấp ban hành'} />
          </Form.Item> */}

        <Form.Item name={'contruction_board'} label={'Ban chủ trì xây dựng'}>
          <Input placeholder={'Nhập ban chủ trì xây dựng'} />
        </Form.Item>

        {/* <Form.Item name={'status'} label={'Trạng thái'}>
            <Select
              showSearch
              allowClear
              placeholder={'Trạng thái'}
              filterOption={true}
              optionFilterProp={'label'}>
              {options.map(opt => (
                <Option key={opt.value} value={opt.value}>
                  {opt.label}
                </Option>
              ))}
            </Select>
          </Form.Item> */}

        <Tabs
          defaultActiveKey="1"
          destroyInactiveTabPane={false}
          style={{
            marginTop: 20,
          }}>
          <Tabs.TabPane tab="Biên bản" key="1" forceRender>
            <Form.Item
              name={'attachment_minutes'}
              label={'Biên bản'}
              rules={[{ required: true, message: 'Vui lòng thêm tài liệu' }]}>
              <Upload.Dragger
                fileList={fileList}
                onChange={handleChangeFile}
                beforeUpload={handleAddFileToUpload}
                multiple={true}
                itemRender={renderFileItem}
                className="custom-dragger-upload bg-white">
                <DraggerUploadButton />
              </Upload.Dragger>
            </Form.Item>
          </Tabs.TabPane>

          <Tabs.TabPane tab="Nghị quyết" key="2" forceRender>
            <Form.Item
              name={'attachment_solution'}
              label={'Nghị quyết'}
              rules={[{ required: true, message: 'Vui lòng thêm tài liệu' }]}>
              <Upload.Dragger
                fileList={fileListNQ}
                onChange={handleChangeFileNQ}
                beforeUpload={handleAddFileToUpload}
                multiple={true}
                itemRender={renderFileItem}
                className="custom-dragger-upload bg-white">
                <DraggerUploadButton />
              </Upload.Dragger>
            </Form.Item>
          </Tabs.TabPane>
        </Tabs>
      </div>

      <div className="custom-create-page-footer-sticky">
        <Button
          danger
          className="custom-ant-button w-160"
          htmlType={'button'}
          onClick={handleCancel}>
          Huỷ bỏ
        </Button>

        <Button
          type={'primary'}
          className="custom-ant-button w-160"
          htmlType={'submit'}>
          Tạo mới
        </Button>
      </div>
    </Form>
  )

  return (
    <DashboardLayout>
      <Helmet>
        <title>Tạo mới biên bản nghị quyết</title>
      </Helmet>

      <AppPageHeader
        title="Tạo biên bản nghị quyết"
        showBackButton
      />

      {renderFormContent()}
    </DashboardLayout>
  )
}

BoardResolutionMinutesCreatePage.propTypes = {}

export default memo(
  inject(
    'loadingAnimationStore',
    'commonStore',
    'documentStore',
    'fileStore',
    'boardResolutionMinutesStore'
  )(observer(BoardResolutionMinutesCreatePage))
)
